import Config from 'config';
import React from 'react';
import { Image } from '@apia/theme';
import MakeField from '../fieldsStore/MakeField';
import { IApiaImage } from '../../../../types';
import useContext from '../../../../hooks/useContext';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import FieldContext from '../fieldsStore/FieldContext';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';
import { useApiaFormContext } from '../page/ApiaForm';
import IProperty from '../../../../JSApi/constants/IProperty';

const getSrc = (url: string | undefined): string => {
  if (url) {
    const rgEx = /^(http|https):\/\//;
    if (rgEx.test(url)) {
      return url;
    }
    return `${Config.APIA_ROOT_CONTEXT}/images/uploaded/${url}`;
  }
  return '';
};

const ApiaImage = MakeField(
  React.forwardRef<HTMLImageElement>((_, ref) => {
    const { fireEvent } = useContext(FieldContext);
    const { field, fieldId } = useContext(ApiaComponentContextPrimitive);
    const { name, ...props } = usePropsSelector(fieldId);

    const { serverEvents, scriptEvents } = field as IApiaImage;

    const hasEvents =
      (serverEvents && serverEvents?.length > 0) ||
      (scriptEvents && scriptEvents?.length > 0);

    const { identifier } = useApiaFieldCommonProps({
      className: 'image__field',
    });
    const { isFormReadOnly } = useApiaFormContext();

    return (
      <>
        {!props.onGrid && !props.attributes.onGrid && <>&nbsp;</>}
        <Image
          ref={ref}
          src={getSrc(props.imageUrl)}
          title={props[IProperty.PROPERTY_TITLE] || props.tooltip}
          alt={props[IProperty.PROPERTY_ALT] || name}
          aria-label={props[IProperty.PROPERTY_ARIA_LABEL]}
          aria-description={props[IProperty.PROPERTY_ARIA_DESCRIPTION]}
          autoFocus={
            props[IProperty.PROPERTY_AUTO_FOCUS] === 'true' ? true : undefined
          }
          {...window.getVariant('layout.execution.form.fields.image')}
          onClick={() => (isFormReadOnly ? undefined : fireEvent('onClick'))}
          onError={() => getSrc('')}
          sx={{
            cursor: hasEvents ? 'pointer' : null,
          }}
          {...identifier}
        />
      </>
    );
  }),
  {
    preSynchronize: () => true,
    doValidate: () => true,
    doSynchronize: () => true,
  },
);

export default ApiaImage;
